<template>
    <div class="mt-md">
        <div class="flex flex-col justify-between space-y-6 sm:flex-row sm:items-center sm:space-y-0">
            <div v-if="status === 'pending'"
                class="space-y-2">
                <div class="flex items-center space-x-2">
                    <v-placeholder class="w-14 rounded-2xs bg-gray-50 text-4xl before:via-gray-100">
                        0.00
                    </v-placeholder>

                    <v-placeholder class="h-6 w-28 rounded-2xs bg-gray-50 before:via-gray-100" />
                </div>

                <v-placeholder class="w-40 rounded-2xs bg-gray-50 text-sm before:via-gray-100">
                    ......
                </v-placeholder>
            </div>

            <div v-else
                class="space-y-2">
                <div class="flex items-center space-x-2">
                    <p class="text-4xl font-bold">{{ rating.toFixed(2) }}</p>

                    <div class="flex items-center space-x-px text-xl">
                        <v-icon v-for="i in 5"
                            :key="i"
                            :icon="getIcon(i, rating)" />
                    </div>
                </div>

                <p class="text-sm">
                    {{ $t('reviews.based-on', totalRatingCount) }}
                </p>
            </div>

            <transition
                enter-active-class="transition-opacity duration-150"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="transition-opacity duration-150"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <v-button v-if="!form"
                    theme="black"
                    @click="form = 'review'">
                    {{ $t('reviews.write-review') }}
                </v-button>
            </transition>
        </div>

        <div class="my-5">
            <transition enter-active-class="transition-opacity duration-150"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="transition-opacity duration-150"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <v-page-product-rating-review-form v-if="form === 'review'"
                    :sku="sku"
                    @close="form = undefined" />
            </transition>
        </div>

        <v-tab-group class="mt-lg lg:mx-0">
            <v-tab-panels>
                <v-tab-panel>
                    <v-page-product-rating-reviews :skus="skus" />
                </v-tab-panel>
            </v-tab-panels>
        </v-tab-group>
    </div>
</template>

<script lang="ts" setup>
const properties = defineProps<{
    sku: string
    skus: string[]
}>();

const form = ref<'review' | 'question' | undefined>();

const {
    getRating,
    getIcon,
} = useReviews();

const {
    rating,
    status,
    totalRatingCount,
} = getRating(properties.skus);
</script>
